import { FormattedMessage } from '@subaio/components'
import { Psd2ErrorType } from '@subaio/psd2login-web'
import { cases } from '@subaio/utils'

type Props = {
	type: Psd2ErrorType
}

export const Psd2loginError = ({ type }: Props) =>
	cases(type, {
		[Psd2ErrorType.Aborted]: (
			<FormattedMessage
				id='flow.accounts.psd2ErrorAborted'
				defaultMessage='You have closed the PSD2 login without adding any banks. Please re-open the flow by pressing "Add financial institutes" and add your financial institutes by selecting your financial institute and logging in.'
			/>
		),
		[Psd2ErrorType.Cancelled]: (
			<FormattedMessage
				id='flow.accounts.psd2ErrorCancelled'
				defaultMessage='Your PSD2 login window closed unexpectedly. Please re-open the flow by pressing "Add financial institutes" to continue.'
			/>
		),
		[Psd2ErrorType.FailedToOpen]: (
			<FormattedMessage
				id='flow.accounts.psd2ErrorFailedToOpen'
				defaultMessage='We could not open the PSD2 flow for you. Please check to make sure your browser does not block pop-ups'
			/>
		),
		[Psd2ErrorType.PartiallyCompleted]: (
			<FormattedMessage
				id='flow.accounts.psd2ErrorPartiallyCompleted'
				defaultMessage='You have closed the PSD2 login before finishing the flow. Please re-open the flow by pressing "Add financial institutes" and submit your financial institutes by pressing "Continue" in the flow.'
			/>
		),
		[Psd2ErrorType.SessionExpired]: (
			<FormattedMessage
				id='flow.accounts.psd2ErrorSessionExpired'
				defaultMessage='Your session has expired because it took too long to complete. Please re-open the flow by pressing "Add financial institutes" to continue.'
			/>
		),
		[Psd2ErrorType.Unknown]: (
			<FormattedMessage id='flow.accounts.psd2ErrorUnknown' defaultMessage='An unexpected error occurred.' />
		),
	})
